import React from 'react';

const PropertyTypeFilter = ({ onFilterChange, activeFilter }) => {
  const filters = [
    { id: 'all', label: window.gwSearch.strings.filter_all },
    { id: 'rentals', label: window.gwSearch.strings.filter_rentals },
    { id: 'sales', label: window.gwSearch.strings.filter_sales }
  ];

  const containerStyle = {
    marginBottom: '20px',
    textAlign: 'center'
  };

  const buttonContainerStyle = {
    display: 'inline-flex',
    background: '#f5f5f5',
    borderRadius: '4px',
    padding: '4px'
  };

  return (
    <div className="property-type-filter" style={containerStyle}>
      <div className="filter-buttons" style={buttonContainerStyle}>
        {filters.map(filter => (
          <button
            key={filter.id}
            className={`filter-button ${activeFilter === filter.id ? 'active' : ''}`}
            onClick={() => onFilterChange(filter.id)}
            style={{
              border: 'none',
              background: activeFilter === filter.id ? '#fff' : 'none',
              padding: '8px 16px',
              borderRadius: '4px',
              cursor: 'pointer',
              fontWeight: 500,
              transition: 'all 0.3s ease',
              boxShadow: activeFilter === filter.id ? '0 2px 4px rgba(0, 0, 0, 0.1)' : 'none'
            }}
          >
            {filter.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default PropertyTypeFilter; 


// WEBPACK FOOTER //
// ./src/components/search/PropertyTypeFilter.js